import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { toggleFixedAlert } from '../../../../../redux/actions/general';
import { getAccessRoutes } from '../../../../../routers/helpers';

const UserLinks = ({ user }) => {
  const dispatch = useDispatch();
  const location = useLocation();

  const fullNavbarRoutes = getAccessRoutes();

  const detectRouteQuery = (item) => {
    switch (item.link) {
    case '/orders':
      return `${item.link}?query=${user?.username}&search_type=3`;

    case '/payments':
    case '/drip-feed':
    case '/subscriptions':
      return `${item.link}?query=${user?.username}&search_type=2`;

    case '/refill':
      return `${item.link}?query=${user?.username}&search_type=4`;

    default:
      break;
    }
  };

  const findAndFormatRoutes = () => {
    const defaultRoutes = ['/orders', '/payments', '/refill', '/drip-feed', '/subscriptions'];
    const userRoutes = [];
    defaultRoutes.forEach((url) => {
      const findRoute = fullNavbarRoutes.find((item) => item.link === url);
      if (findRoute) {
        userRoutes.push({ ...findRoute, shareLink: detectRouteQuery(findRoute) });
      }
    });

    return userRoutes;
  };

  const onClickRoute = () => dispatch(toggleFixedAlert(true, location.pathname + location.search));

  return (
    <>
      {fullNavbarRoutes.find((route) => route.link === '/users') ? (
        <Link to={`/users?user_id=${user?.id}`} onClick={onClickRoute} className="details__username" title={user?.username}>
          {user?.username}
        </Link>
      ) : <span className="details__username">{user?.username}</span>}
      <ul className="details__links-nav">
        {findAndFormatRoutes().map((item) => (
          <li role="presentation" key={item.id}>
            {item.component ? (
              <Link to={item.shareLink} onClick={onClickRoute} className="text-decoration-none">
                {item.name}
              </Link>
            ) : (
              <a href={`/admin${item.shareLink}`} className="text-decoration-none">{item.name}</a>
            )}
          </li>
        ))}
      </ul>
    </>
  );
};

UserLinks.propTypes = {
  user: PropTypes.object,
};

export default UserLinks;
